import { defineComponent as _defineComponent } from 'vue'
import { ref } from '@nuxtjs/composition-api';
import BravadoSelectV3 from '@/components/common/BravadoSelectV3/BravadoSelectV3.vue';
import BravadoTextInputV3 from '@/components/common/BravadoTextInputV3/BravadoTextInputV3.vue';
import type { SelectableOption } from '@/components/partials/public-portfolio/PortfolioJobsInquirySection/PortfolioJobsInquirySectionProfile/types';

type JobsMultiselectWithCustomOptionProps = {
  options: SelectableOption[];
  label: string;
  attributeNameMain: string;
  attributeNameOther: string;
  placeholder?: string;
  mainValue?: string[] | null;
  otherValue?: string | null;
  isValid?: boolean;
  hint?: string;
};
type JobsMultiselectWithCustomOptionEmits = {
  (
    event: 'change',
    payload: {
      [key: string]: string | string[] | null;
    },
  ): void;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'JobsMultiselectWithCustomOption',
  props: {
    options: null,
    label: null,
    attributeNameMain: null,
    attributeNameOther: null,
    placeholder: { default: '' },
    mainValue: { default: null },
    otherValue: { default: null },
    isValid: { type: Boolean, default: true },
    hint: { default: '' }
  },
  emits: ["change"],
  setup(__props: any, { emit }: { emit: ({
  (
    event: 'change',
    payload: {
      [key: string]: string | string[] | null;
    },
  ): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { options: SelectableOption[], label: string, attributeNameMain: string, attributeNameOther: string, placeholder: string, mainValue: string[] | null, otherValue: string | null, isValid: boolean, hint: string };




const selectedMainValue = ref(props.mainValue);
const selectedOtherValue = ref(props.otherValue);

function handleChange(): void {
  emit('change', {
    [props.attributeNameMain]: selectedMainValue.value,
    [props.attributeNameOther]: (selectedOtherValue.value || '').trim(),
  });
}

return { __sfc: true,props, emit, selectedMainValue, selectedOtherValue, handleChange, BravadoSelectV3, BravadoTextInputV3 }
}

})